export const useResponseErrorParser = () => {
    const parseResponse = (responseMessage) => {
        const regexResult = responseMessage.match(/(Почтовый адрес.+)/);
        return regexResult ? regexResult[0] : responseMessage;
    };
    return { parseResponse };
};
